import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { StudentShell, AdminGuard, PublicOnly } from "@/components/Shells";
import { ErrorBoundary } from "@/components/ErrorBoundary";

import Splash from "@/pages/Splash";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Home from "@/pages/Home";
import Carteira from "@/pages/Carteira";
import Certificados from "@/pages/Certificados";
import ValidarCertificado from "@/pages/ValidarCertificado";
import Calendario from "@/pages/Calendario";
import CursoDetalhe from "@/pages/CursoDetalhe";
import CursosGratuitos from "@/pages/CursosGratuitos";
import CursoGratuitoDetalhe from "@/pages/CursoGratuitoDetalhe";
import BancoIdeias from "@/pages/BancoIdeias";
import Sugestoes from "@/pages/Sugestoes";
import Beneficios from "@/pages/Beneficios";
import Notificacoes from "@/pages/Notificacoes";
import Perfil from "@/pages/Perfil";
import Materiais from "@/pages/Materiais";
import Consultorias from "@/pages/Consultorias";
import Conquistas from "@/pages/Conquistas";
import PesquisaSatisfacao from "@/pages/PesquisaSatisfacaoV2";
import PoliticaPrivacidade from "@/pages/PoliticaPrivacidade";
import TermosUso from "@/pages/TermosUso";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsuarios from "@/pages/admin/AdminUsuarios";
import AdminCursosPresenciais from "@/pages/admin/AdminCursosPresenciais";
import AdminCursosGratuitos from "@/pages/admin/AdminCursosGratuitos";
import AdminEventos from "@/pages/admin/AdminEventos";
import AdminLeitorQR from "@/pages/admin/AdminLeitorQR";
import AdminCertificados from "@/pages/admin/AdminCertificados";
import AdminPendencias from "@/pages/admin/AdminPendencias";
import AdminModelosCertificado from "@/pages/admin/AdminModelosCertificado";
import AdminMatriculas from "@/pages/admin/AdminMatriculas";
import AdminBeneficios from "@/pages/admin/AdminBeneficios";
import AdminNotificacoes from "@/pages/admin/AdminNotificacoes";
import AdminSugestoes from "@/pages/admin/AdminSugestoes";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminBancoIdeias from "@/pages/admin/AdminBancoIdeias";
import AdminMateriais from "@/pages/admin/AdminMateriais";
import AdminConsultorias from "@/pages/admin/AdminConsultorias";
import AdminKitsVIP from "@/pages/admin/AdminKitsVIP";
import AdminConquistas from "@/pages/admin/AdminConquistas";
import AdminImportAlunos from "@/pages/admin/AdminImportAlunos";
import AdminAuditoria from "@/pages/admin/AdminAuditoria";
import AdminEmail from "@/pages/admin/AdminEmail";
import AdminPesquisas from "@/pages/admin/AdminPesquisas";
import AdminModeloPesquisa from "@/pages/admin/AdminModeloPesquisa";
import AdminGestaoAcessos from "@/pages/admin/AdminGestaoAcessos";
import AdminLogsAcesso from "@/pages/admin/AdminLogsAcesso";
import MustChangePasswordGate from "@/components/MustChangePasswordGate";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
          <MustChangePasswordGate />
          <Routes>
            <Route path="/" element={<Splash />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/admin/login" element={<PublicOnly><Login admin /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/validar/:code" element={<ValidarCertificado />} />
            <Route path="/validar" element={<ValidarCertificado />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/termos-de-uso" element={<TermosUso />} />

            {/* Student routes inside shell */}
            <Route element={<StudentShell />}>
              <Route path="/home" element={<Home />} />
              <Route path="/carteira" element={<Carteira />} />
              <Route path="/certificados" element={<Certificados />} />
              <Route path="/calendario" element={<Calendario />} />
              <Route path="/calendario/:id" element={<CursoDetalhe />} />
              <Route path="/cursos-gratuitos" element={<CursosGratuitos />} />
              <Route path="/cursos-gratuitos/:id" element={<CursoGratuitoDetalhe />} />
              {/* Alias: novo nome do módulo "Aulas Gratuitas" */}
              <Route path="/aulas-gratuitas" element={<CursosGratuitos />} />
              <Route path="/aulas-gratuitas/:id" element={<CursoGratuitoDetalhe />} />
              <Route path="/banco-ideias" element={<BancoIdeias />} />
              <Route path="/sugestoes" element={<Sugestoes />} />
              <Route path="/beneficios" element={<Beneficios />} />
              <Route path="/notificacoes" element={<Notificacoes />} />
              <Route path="/perfil" element={<Perfil />} />
              <Route path="/materiais" element={<Materiais />} />
              <Route path="/consultorias" element={<Consultorias />} />
              <Route path="/conquistas" element={<Conquistas />} />
              <Route path="/pesquisa-satisfacao/:courseId" element={<PesquisaSatisfacao />} />
            </Route>

            {/* Admin routes */}
            <Route path="/admin/dashboard" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
            <Route path="/admin/usuarios" element={<AdminGuard><AdminUsuarios /></AdminGuard>} />
            <Route path="/admin/cursos-presenciais" element={<AdminGuard><AdminCursosPresenciais /></AdminGuard>} />
            <Route path="/admin/matriculas" element={<AdminGuard><AdminMatriculas /></AdminGuard>} />
            <Route path="/admin/cursos-gratuitos" element={<AdminGuard><AdminCursosGratuitos /></AdminGuard>} />
            <Route path="/admin/eventos" element={<AdminGuard allow={["admin_master", "operador_evento"]}><AdminEventos /></AdminGuard>} />
            <Route path="/admin/leitor-qr" element={<AdminGuard allow={["admin_master", "operador_evento"]}><AdminLeitorQR /></AdminGuard>} />
            <Route path="/admin/certificados" element={<AdminGuard><AdminCertificados /></AdminGuard>} />
            <Route path="/admin/pendencias-presenca" element={<AdminGuard><AdminPendencias /></AdminGuard>} />
            <Route path="/admin/modelos-certificado" element={<AdminGuard><AdminModelosCertificado /></AdminGuard>} />
            <Route path="/admin/beneficios" element={<AdminGuard><AdminBeneficios /></AdminGuard>} />
            <Route path="/admin/notificacoes" element={<AdminGuard><AdminNotificacoes /></AdminGuard>} />
            <Route path="/admin/sugestoes" element={<AdminGuard><AdminSugestoes /></AdminGuard>} />
            <Route path="/admin/leads" element={<AdminGuard allow={["admin_master", "comercial"]}><AdminLeads /></AdminGuard>} />
            <Route path="/admin/banco-ideias" element={<AdminGuard><AdminBancoIdeias /></AdminGuard>} />
            <Route path="/admin/materiais" element={<AdminGuard><AdminMateriais /></AdminGuard>} />
            <Route path="/admin/consultorias" element={<AdminGuard><AdminConsultorias /></AdminGuard>} />
            <Route path="/admin/kits-vip" element={<AdminGuard><AdminKitsVIP /></AdminGuard>} />
            <Route path="/admin/conquistas" element={<AdminGuard><AdminConquistas /></AdminGuard>} />
            <Route path="/admin/import-alunos" element={<AdminGuard><AdminImportAlunos /></AdminGuard>} />
            <Route path="/admin/auditoria" element={<AdminGuard><AdminAuditoria /></AdminGuard>} />
            <Route path="/admin/email" element={<AdminGuard><AdminEmail /></AdminGuard>} />
            <Route path="/admin/pesquisas" element={<AdminGuard><AdminPesquisas /></AdminGuard>} />
            <Route path="/admin/modelo-pesquisa" element={<AdminGuard><AdminModeloPesquisa /></AdminGuard>} />
            <Route path="/admin/gestao-acessos" element={<AdminGuard><AdminGestaoAcessos /></AdminGuard>} />
            <Route path="/admin/logs-acesso" element={<AdminGuard><AdminLogsAcesso /></AdminGuard>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
